import { render, staticRenderFns } from "./mechanismQRcode.vue?vue&type=template&id=352d828e"
import script from "./mechanismQRcode.vue?vue&type=script&lang=js"
export * from "./mechanismQRcode.vue?vue&type=script&lang=js"
import style0 from "./mechanismQRcode.vue?vue&type=style&index=0&id=352d828e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports